import { ETypographyIntents } from '@src/typings';
import { TimeRangePickerProps } from 'antd';
import clsx from 'clsx';
import { FormLabel } from '../FormLabel';
import { useTheme, withTheme } from '../ThemeProvider';
import { Typography } from '../Typography';
import { StyledTimePickerPanel, StyledTimeRangePicker } from './styles';

interface ITimeRangePicker extends TimeRangePickerProps {
    label?: string;
    error?: string;
    required?: boolean;
    className?: string;
}

function TimeRangePickerComponent(props: ITimeRangePicker) {
    const { label, required, error, className, ...rest } = props;
    const { theme } = useTheme();

    return (
        <div className="space-y-2.5 flex flex-col">
            {label ? <FormLabel label={label} required={required} /> : null}
            <StyledTimeRangePicker
                {...rest}
                size="large"
                showSecond={false}
                className={clsx(className, '')}
                panelRender={(originalPanel) => (
                    <StyledTimePickerPanel>
                        {originalPanel}
                    </StyledTimePickerPanel>
                )}
            />
            <Typography
                intent={ETypographyIntents.Badge}
                className="mt-1"
                style={{ color: theme.colors.error.main.filled }}
            >
                {error}
            </Typography>
        </div>
    );
}
export const TimeRangePicker = withTheme(TimeRangePickerComponent);
